exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ng-invalid {\n  border-color: red;\n}\n\n/***************    COMPONENT USER    ***********/\n\n.applystatuses .row-padding {\n  padding-left: 20px;\n  padding-bottom: 20px;\n}\n\n.applystatuses .inp-dir {\n    width: 55px;\n    color: #9e9e9e;\n}\n\n.applystatuses .slc-dir {\n    width: 100px;\n    color: #9e9e9e;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/apply-status/apply-status.component.css
// module id = ../../../../../src/app/pages/apply-status/apply-status.component.css
// module chunks = main